module.exports = __webpack_public_path__ + "img/tracked_image.86d0fb9c.gif";